import ComponentFactory from "./ComponentFactory";
import { AdminDashboard } from "./pages/Admin";
import { Billing } from "./pages/Billing";
import { Dashboard } from "./pages/Dashboard";
import { Plans } from "./pages/Plans";
import { Success } from "./pages/Success";
import { LandingPage } from "./pages/landing";
import { LoginPage } from "./pages/login";
import { SignupPage } from "./pages/signup";
import { DetailsPage } from "./pages/sitedetails";
import { TemplatePage } from "./pages/template";
import { ForgotPasswordPage } from "./pages/forgotPassword";
import { ResetPasswordPage } from "./pages/resetPassword";
import { ErrorPage } from "./pages/error";
ComponentFactory.set("Login Page", LoginPage);
ComponentFactory.set("Signup Page", SignupPage);
ComponentFactory.set("Landing Page", LandingPage);
ComponentFactory.set("Dashboard Page", Dashboard);
ComponentFactory.set("AdminDashboard Page", AdminDashboard);
ComponentFactory.set("Success Page", Success);
ComponentFactory.set("Templates Page", TemplatePage);
ComponentFactory.set("Details Page", DetailsPage);
ComponentFactory.set("Billing Page", Billing);
ComponentFactory.set("Plan Page", Plans);
ComponentFactory.set("Forgot Password Page", ForgotPasswordPage);
ComponentFactory.set("Reset Password Page", ResetPasswordPage);
ComponentFactory.set("Error Page", ErrorPage);
